/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
import { Icon } from 'assets/index'
import { useContext, useEffect, useRef, useState } from 'react'
import { Form } from '@unform/web'
import { IResponse } from 'interfaces'
import { MaskedInput, ButtonNext, Path } from 'components/index'
import { UserContext } from 'context/userContext'
import { moneyToNumber, dateToTimestamp } from 'helper/utils'
import useFetch from 'hooks/useFetch'
import { Theme } from 'styles/Themes'
import { Container } from './style'

const info = [
  {
    title: 'Comissão de vendas',
    value: [
      {
        title: 'Diretor',
        target: 'GESTOR',
        values: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
      },
      {
        title: 'Gestor',
        target: 'RH',
        values: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
      },
      {
        title: 'Especialista',
        target: 'SPECIALIST',
        values: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
      },
    ],
  },
  {
    title: 'Comissão de gestão de carteira',
    value: [
      {
        title: 'Gestão Diretor',
        target: 'GESTOR',
        values: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
      },
      {
        title: 'Gestão Gestor',
        target: 'RH',
        values: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
      },
      {
        title: 'Gestão Especialista',
        target: 'SPECIALIST',
        values: [
          [0, 0, 0],
          [0, 0, 0],
          [0, 0, 0],
        ],
      },
    ],
  },
]

export default function Comission() {
  const {
    data,
    setData,
    setAllowNextPage,
    requestFn,
    feedback,
    page,
    toggleCap,
    setPage,
  } = useContext(UserContext)
  const formRef = useRef<HTMLFormElement | any>(null)
  const api = useFetch('/')

  useEffect(() => {
    setData((old: any) => ({
      ...old,
      comission: {
        // goal: '',
        // share: '',
        distribution: info,
      },
    }))
  }, [])

  const handleChangeValue = (
    comiss: any,
    person: any,
    row: any,
    index: number,
    target: any
  ) => {
    const newState = [...data.comission.distribution]
    const newValue = [...newState[comiss].value]
    const newValues = [...newValue[person].values]

    newValues[row][index] = target

    newValue[person].values = newValues
    newState[comiss].value = newValue

    setData((old: any) => {
      return {
        ...old,
        comission: {
          ...old.comission,
          distribution: newState,
        },
      }
    })
  }

  const setBorder = (comiss: any, person: any, row: any) => {
    const line = data?.comission?.distribution[comiss].value[person].values[row]
    const allZero = line?.every((value: any) => value === 0)
    const allNonZero = line?.every(
      (value: any) => value !== 0 && value && value! === ''
    )

    return allNonZero || allZero
  }

  const handleSubmit = () => {
    const checkValuesConsistency = () => {
      let isConsistent = true

      data?.comission?.distribution.forEach((entry: any) => {
        entry.value.forEach((item: any) => {
          let changedFromZero = false
          let allNonZero = true

          item.values.forEach((subArray: any) => {
            const allZero = subArray.every((value: any) => value === 0)
            const allNonZeroInSubArray = subArray.every(
              (value: any) => value !== 0
            )

            if (!allZero && !allNonZeroInSubArray) {
              isConsistent = false
            }

            if (allZero && !allNonZeroInSubArray) {
              changedFromZero = true
            }

            if (!changedFromZero && !allZero && !allNonZeroInSubArray) {
              allNonZero = false
            }
          })

          if (changedFromZero && !allNonZero) {
            isConsistent = false
          }
        })
      })

      return isConsistent
    }

    if (!checkValuesConsistency()) return

    const datesForm = {
      releaseAt: dateToTimestamp(data?.releaseAt),
      startedAt: dateToTimestamp(data?.startedAt),
      tradeAt: dateToTimestamp(data?.tradeAt),
      createdAt: dateToTimestamp(data?.createdAt),
    }

    if (toggleCap === 'Proposta personalizada') {
      delete datesForm.releaseAt
    }

    const extractValues = (obj: any) => {
      if (!obj) return {}
      const extractedObj: any = {}

      Object.entries(obj).forEach(([key, value]: any) => {
        if (value === null) return
        if (typeof value === 'object' && 'value' in value) {
          extractedObj[key] = value.value
        } else {
          extractedObj[key] = value
        }
      })

      return extractedObj
    }
    console.log('chega assim', data?.guaranteeList)
    let formatedData = {
      ...extractValues(data),
      ...datesForm,
      // bonus: [data.bonusMonths.value, data.profitabilityBonus],
      guaranteeList:
        Array.isArray(data?.guaranteeList) &&
        data.guaranteeList.some((v: any) => v.value === 'Não possui')
          ? ['Não possui']
          : data?.guaranteeList?.map((v: any) => v.value),
    }
    if (data.profitabilityBonus) {
      formatedData = {
        ...formatedData,
        bonus: [
          Number(data.bonusMonths.value),
          Number(data.profitabilityBonus),
        ],
      }
    }
    console.log('DATA FORMATADO', formatedData)
    const form = new FormData()

    Object.entries(formatedData).forEach(([key, value]: any) => {
      if (key === 'header') return form.append(key, value, value.name)
      if (typeof value === 'object' || Array.isArray(value))
        value = JSON.stringify(value)
      else if (!value) return
      form.append(key, value)
    })
    const dadosObj = Object.fromEntries(form.entries())
    console.log('FORMDATA', dadosObj)
    feedback.current = { title: 'Captação criada!', error: false }
    requestFn.current = async () => {
      try {
        console.log('chamou foi o request da captacao')
        const response: IResponse = await api.fetch('post', form, '/token', {
          'Content-type': 'multipart/form-data',
        })

        return response
      } catch (err: any) {
        console.log('err', err)
        return err
      }
    }
    setPage((prev) => prev + 1)
  }

  return (
    <Container>
      <Path className="path">
        <span className="path">
          {
            'Gestão de produtos >  Investimentos  > Nova captação  > Layout > Detalhes da nova captação > Política de comissionamento'
          }
        </span>
      </Path>
      <Form ref={formRef} onSubmit={() => console.log('submit')}>
        <div>
          <h1 className="new-colaborator-title">Política de comissionamento</h1>
          <div className="new-colaborator-subtitle">
            <img src={Icon('trophy.svg')} alt="subtitle icon" />
            <h4>Comissão de equipe</h4>
          </div>

          <span className="span-novo">Meta da equipe</span>

          <div className="new-colaborator-container">
            <MaskedInput
              smallPad
              disabled
              type="money"
              handleChange={(e: any) =>
                setData((old: any) => ({
                  ...old,
                  comission: {
                    ...old.comission,
                    goal: moneyToNumber(e.target.value),
                  },
                }))
              }
              placeholder="Meta de venda"
              name="meta"
              defaultValue={data?.comission?.goal}
            />
            <MaskedInput
              smallPad
              disabled
              type="jurosaa"
              handleChange={(e: any) =>
                setData((old: any) => ({
                  ...old,
                  comission: {
                    ...old.comission,
                    share: e.target.value,
                  },
                }))
              }
              placeholder="Porcentagem de comissão"
              name="meta"
              defaultValue={data?.comission?.share}
            />
          </div>

          {info.map((comiss, i) => {
            return (
              <>
                <div
                  className="new-colaborator-subtitle"
                  key={`new-colaborator-subtitle-${i}`}
                >
                  <img src={Icon('trophy.svg')} alt="subtitle icon" />
                  <h4>{comiss.title}</h4>
                </div>
                <>
                  {comiss.value.map((person, t) => {
                    return (
                      <>
                        <span className="span-novo">{person.title}</span>
                        <div className="new-colaborator-container">
                          {person.values.map((rows, j) => {
                            return (
                              <div
                                className="new-colaborator-container"
                                style={{
                                  width: '100%',
                                }}
                              >
                                <MaskedInput
                                  smallPad
                                  disabled
                                  type="money"
                                  handleChange={(e: any) => {
                                    handleChangeValue(
                                      i,
                                      t,
                                      j,
                                      0,
                                      Number(moneyToNumber(e.target.value))
                                    )
                                  }}
                                  placeholder="R$"
                                  name="meta"
                                  defaultValue={rows[0]}
                                />
                                <span className="ate">até</span>
                                <MaskedInput
                                  smallPad
                                  disabled
                                  type="money"
                                  handleChange={(e: any) => {
                                    handleChangeValue(
                                      i,
                                      t,
                                      j,
                                      1,
                                      Number(moneyToNumber(e.target.value))
                                    )
                                  }}
                                  placeholder="R$"
                                  name="meta"
                                  defaultValue={rows[1]}
                                />
                                <MaskedInput
                                  smallPad
                                  disabled
                                  type="percent"
                                  handleChange={(e: any) => {
                                    handleChangeValue(
                                      i,
                                      t,
                                      j,
                                      2,
                                      Number(moneyToNumber(e.target.value)) /
                                        100
                                    )
                                  }}
                                  placeholder="Porcentagem de comissão"
                                  name="meta"
                                  defaultValue={rows[0]}
                                />

                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: setBorder(i, t, j)
                                      ? 'transparent'
                                      : Theme.pallete.SENARY,
                                  }}
                                >
                                  *
                                </span>
                              </div>
                            )
                          })}
                        </div>
                      </>
                    )
                  })}
                </>
              </>
            )
          })}
        </div>
        <ButtonNext
          isAdvance
          advancePage={() => handleSubmit()}
          isBack
          backPage={() => setPage((prev) => prev - 1)}
          // backPage={backTablePage}
        />
      </Form>
    </Container>
  )
}
